module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Italic.dc3a277b.woff";